export default {
  isOverviewChartShown: 'Pokaż wykres przeglądowy',
  isZoomedChartShown: 'Pokaż wykres przybliżony do pasma tolerancji',
  isSectionsTableShown: 'Pokaż tabelę odcinków',
};
